import type { ParsedUrlQuery } from 'querystring';

import type { useRouter } from 'next/router';

import { affiliatesPageRouteWithSpecificAffIdAndSource } from '@src/shared/constants/pageRoutes';
import { getRoutePathParams } from '@src/utils/getRoutePathParams';
import { isAffiliatesPageRoute, isExactMainPage } from '@src/utils/routing';

export function getPropogationParams(router: ReturnType<typeof useRouter>): ParsedUrlQuery {
  const path = router.asPath.split('?').at(0) ?? '';

  if (!isAffiliatesPageRoute(path)) {
    return {};
  }

  const transactionId = router.query?.root_transaction_id as string | undefined;

  if (!transactionId) {
    return {};
  }

  return {
    root_transaction_id: transactionId,
  };
}

export function getPositionFromUrl(router: ReturnType<typeof useRouter>): string | undefined {
  const routeParams = getRoutePathParams(affiliatesPageRouteWithSpecificAffIdAndSource, router.asPath);
  if (routeParams?.source) {
    return routeParams.source;
  }
  if (isExactMainPage(router.asPath)) {
    return router?.query?.source as string;
  }

  return undefined;
}
